module.exports = __webpack_public_path__ + "img/jira.f53a2e82.png";